<script setup lang="ts">
import type Article from "~~/types/Article";

const props = defineProps({
    article: {
        type: Object as PropType<Article>,
        required: true,
    },
});

const { formatDate } = useHelper();
</script>

<template>
    <div class="bg-abc-gray p-4">
        <H1Heading
            size="text-2xl md:text-3xl"
            class="mb-2 text-center"
            >{{ article.title }}</H1Heading
        >
        <div class="mb-2 text-center md:mb-0 md:text-lg">
            <div
                v-if="article.author"
                class="md:inline"
            >
                By {{ article.author }}
            </div>
        </div>
        <div class="flex justify-center md:px-8 md:py-4">
            <img
                :src="article?.cover_image?.url"
                :alt="'Cover Image'"
                class="max-h-[600px] overflow-hidden rounded-2xl"
            />
        </div>
    </div>
</template>

<style scoped></style>
